// Sky condition options based on new Meteoblue Daily list
// Based on official Meteoblue documentation: https://docs.meteoblue.com/en/meteo/variables/pictograms

export interface SkyConditionOption {
  value: string;
  label: string;
}

// New sky condition options - value and label are the same (text-based)
export const SKY_CONDITION_OPTIONS: SkyConditionOption[] = [
  { value: 'Clear and few clouds', label: 'Clear and few clouds' },
  { value: 'Clear, cloudless sky', label: 'Clear, cloudless sky' },
  {
    value: 'Cloudy with thunderstorms and heavy showers',
    label: 'Cloudy with thunderstorms and heavy showers'
  },
  { value: 'Fog', label: 'Fog' },
  { value: 'Mixed with showers', label: 'Mixed with showers' },
  { value: 'Mixed with snow showers', label: 'Mixed with snow showers' },
  {
    value: 'Mostly clear with a chance of local thunderstorms',
    label: 'Mostly clear with a chance of local thunderstorms'
  },
  { value: 'Mostly cloudy', label: 'Mostly cloudy' },
  {
    value: 'Mostly cloudy with a mixture of snow and rain',
    label: 'Mostly cloudy with a mixture of snow and rain'
  },
  {
    value: 'Mostly cloudy with occasional rain',
    label: 'Mostly cloudy with occasional rain'
  },
  {
    value: 'Mostly cloudy with occasional snow',
    label: 'Mostly cloudy with occasional snow'
  },
  { value: 'Mostly cloudy with rain', label: 'Mostly cloudy with rain' },
  { value: 'Mostly cloudy with snow', label: 'Mostly cloudy with snow' },
  {
    value: 'Mostly cloudy with thunderstorms and showers',
    label: 'Mostly cloudy with thunderstorms and showers'
  },
  { value: 'Overcast', label: 'Overcast' },
  {
    value: 'Overcast with occasional rain',
    label: 'Overcast with occasional rain'
  },
  {
    value: 'Overcast with occasional snow',
    label: 'Overcast with occasional snow'
  },
  { value: 'Overcast with rain', label: 'Overcast with rain' },
  { value: 'Overcast with snow', label: 'Overcast with snow' },
  { value: 'Partly cloudy', label: 'Partly cloudy' },
  {
    value: 'Partly cloudy with a chance of local thunderstorms',
    label: 'Partly cloudy with a chance of local thunderstorms'
  },
  {
    value: 'Partly cloudy with local thunderstorms and showers possible',
    label: 'Partly cloudy with local thunderstorms and showers possible'
  },
  {
    value: 'Showers, thunderstorms likely',
    label: 'Showers, thunderstorms likely'
  },
  { value: 'Unknown', label: 'Unknown' }
];

export const getSkyConditionLabel = (skyCondition: string): string => {
  const option = SKY_CONDITION_OPTIONS.find(opt => opt.value === skyCondition);
  return option?.label || skyCondition || '';
};
